import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  className?: string;
}

const BasicBlueprint = (props: Props): ReactElement => {
  const { width, height, style, className } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 20"
      style={style}
      className={className}
    >
      <path
        d="M3.25,0c1.333,0 2.479,0.803 2.98,1.951l0.02,0.049l14.75,0c1.64,0 2.973,1.31 3,2.935l0,12.08c0,1.632 -1.316,2.958 -2.95,2.985l-18.05,0c-1.64,0 -2.973,-1.31 -3,-2.935l0,-13.815c0,-1.795 1.455,-3.25 3.25,-3.25Zm17.757,3.5l-14.507,0l0,13.125l-0.002,0l0.002,0.071l0,0.054c-0.014,0.438 -0.248,0.657 -0.702,0.657c-0.453,0 -0.72,-0.22 -0.798,-0.657c0,-0.966 -0.784,-1.75 -1.75,-1.75c-0.966,0 -1.75,0.784 -1.75,1.75c0,0.953 0.762,1.729 1.71,1.75l17.797,0c0.816,0 1.48,-0.647 1.5,-1.453l0,-12.056c0,-0.81 -0.65,-1.47 -1.462,-1.49l-0.038,-0.001Zm-1.382,1.625c0.552,0 1,0.448 1,1l0,6.406c0.003,0.026 0.004,0.053 0.004,0.08c0,0.028 -0.001,0.055 -0.004,0.081l0,3.058c0,0.552 -0.448,1 -1,1l-10.5,0c-0.552,0 -1,-0.448 -1,-1l0,-9.625c0,-0.552 0.448,-1 1,-1l10.5,0Zm-5.03,1.5l-4.97,0l0,3.25l2.519,0l0,-1.52c0,-0.414 0.335,-0.75 0.75,-0.75c0.404,0 0.734,0.32 0.75,0.722l0,5.844c0,0.414 -0.336,0.75 -0.75,0.75c-0.405,0 -0.735,-0.32 -0.75,-0.722l0,-2.824l-2.519,0l0,3.875l9.5,0l0,-1.889l-2.31,0c-0.414,0 -0.75,-0.335 -0.75,-0.75c0,-0.404 0.32,-0.734 0.722,-0.749l2.338,0l0,-5.237l-3.03,0l0,1.999l1.443,0c0.405,0 0.735,0.32 0.75,0.722l0,0.028c0,0.405 -0.32,0.734 -0.722,0.75l-2.97,0l0,-3.499l-0.001,0Zm-11.345,-5.125c-0.953,0 -1.729,0.762 -1.75,1.71l0,10.802c0.505,-0.324 1.106,-0.511 1.75,-0.511c0.644,0 1.245,0.188 1.75,0.511l0,-10.762c0,-0.966 -0.784,-1.75 -1.75,-1.75Z"
        fillRule="nonzero"
      />
    </svg>
  );
};

BasicBlueprint.defaultProps = {
  width: '20px',
  height: '19px',
  style: {},
  className: '',
};

export default BasicBlueprint;
